var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { post, removeAccessToken, setAccessToken } from './api';
import { ELocalStorageKeys } from '../types/auth';
export const removeToken = () => {
    localStorage.removeItem(ELocalStorageKeys.TOKEN);
    removeAccessToken();
};
export const ejectToken = () => localStorage[ELocalStorageKeys.TOKEN];
export const loadAuth = (data) => {
    if (data) {
        localStorage.setItem(ELocalStorageKeys.TOKEN, data.token);
        setAccessToken(data.token);
        return data.token;
    }
    if (localStorage[ELocalStorageKeys.TOKEN]) {
        setAccessToken(localStorage[ELocalStorageKeys.TOKEN]);
        return localStorage[ELocalStorageKeys.TOKEN];
    }
    removeAccessToken();
    return null;
};
export const getToken = (data) => __awaiter(void 0, void 0, void 0, function* () {
    // console.log('api/auth getToken', data)
    const response = yield post({ path: '/v1/auth/get-token', data });
    // console.log('auth response', response)
    return response;
    // return mockAuthData
});
